import React from "react";
import PropTypes from "prop-types";
import { Component } from "react";
import HelperContent from "../../helperContent/HelperContent";
import QuestionLabel from "../../question/QuestionLabel";
import { findAnswer } from '../../../state/questionStates';

class QuoteResults extends Component {
    displayTextForKey(key) {
        switch(key) {
            case "first_name":
                return "First Name";
            case "last_name":
                return "Last Name";
            case "email":
                return "Email";
            case "address_1":
                return "Address Line 1";
            case "address_2":
                return "Address Line 2";
            case "city":
                return "City";
            case "state":
                return "State";
            case "zip":
                return "Postal Code";
            case "home_rent":
                return "Policy Type";
            case "premium":
                return "Premium";
            case "company":
                return "Company";
            case "deductible":
                return "Deductible";
            case "effective_date":
                return "Effective Date";
            case "coverage_a":
                return "Coverage A";
            case "coverage_b":
                return "Coverage B";
            case "coverage_c":
                return "Coverage C";
            case "coverage_d":
                return "Coverage D";
            case "coverage_e":
                return "Coverage E";
            case "coverage_f":
                return "Coverage F";
            default:
                return "";
        }
    }

    render() {
        let question = this.props.question;
        let store = this.props.store;
        let state = store.getState();
        let homeRent = findAnswer(state, "home-rent", "homeOrRental");
        let quoteItems = [], coverageItems = [], addressItems = [];
        let quoteKeys = ["company", "home_rent", "premium", "deductible", "effective_date"];
        let coverageKeys = ["coverage_a", "coverage_b", "coverage_c", "coverage_d", "coverage_e", "coverage_f"];
        let homeRentAddressKeys = ["first_name", "last_name", "email", "address_1", "address_2", "city", "state", "zip"];
        let autoAddressKeys = ["first_name", "last_name", "email"];

        for(let i = 0; i < quoteKeys.length; i++) {
            let value = state.resultData[quoteKeys[i]];
            if (i === 2 || i === 3) {
                let digitStr = value.trim().substring(0, 1);
                let digit = parseInt(digitStr);
                if (!isNaN(digit)) {
                    value = "$" + value.trim();
                }
            }
            if (i < 5) {
                quoteItems.push(
                    <tr key={quoteKeys[i]}>
                        <td>{this.displayTextForKey(quoteKeys[i])}</td>
                        <td><b>{value}</b></td>
                    </tr>);
            }
        }

        if (homeRent.value !== "Auto"){
            for(let i = 0; i < coverageKeys.length; i++) {
                let value = state.resultData[coverageKeys[i]];
                let digitStr = value.trim().substring(0, 1);
                let digit = parseInt(digitStr);
                if (!isNaN(digit)) {
                    value = "$" + value.trim();
                }
                coverageItems.push(
                        <tr key={coverageKeys[i]}>
                            <td>{this.displayTextForKey(coverageKeys[i])}</td>
                            <td>{value}</td>
                        </tr>);
            }
        }

        let keys = homeRent.value === "Auto" ? autoAddressKeys : homeRentAddressKeys;
        for(let i = 0; i < keys.length; i++) {
            let keyText = this.displayTextForKey(keys[i]);
            let value = state.resultData[keys[i]];
            console.log("Rendering: " + keyText + " '" + value + "'");
            addressItems.push(
                <tr key={keys[i]}>
                    <td>{keyText}</td>
                    <td>{value ? value : ""}</td>
                </tr>);
        }

        /*
        {"status":"quote done","first_name":"manny","last_name":"paras","address_1":"Sample Address Prt","address_2":"","city":"HUENEME","state":"CA",
        "zip":"93041","home_rent":"home","premium":"530.00","company":"GEICO","deductible":"1000.00","coverage_a":"xxx","coverage_b":"30100",
        "coverage_c":"40000.00","coverage_d":"60200","coverage_e":"300000.00","coverage_f":"1000","effective_date":"07-04-2020"}
        */
        let coverages = null;
        if (homeRent.value !== "Auto") {
            coverages = (
            <div>
                <b>Coverages</b>
                <table className="w3-table-all">
                    <tbody>{coverageItems}</tbody>
                </table>
                <br/>
            </div>);
        }

        return (
            <div className="form w3-header w3-animate-opacity">
                <QuestionLabel question={question} store={store}/>
                <HelperContent question={question} />
                <br/>

                <b>Quote</b>
                <table className="w3-table-all">
                    <tbody>{quoteItems}</tbody>
                </table>
                <br/>
                {coverages}
                <b>Your Information</b>
                <table className="w3-table-all">
                    <tbody>{addressItems}</tbody>
                </table>
            </div>
        )
    }
};

QuoteResults.propTypes = {
    question: PropTypes.object,
    store: PropTypes.object
};

export default QuoteResults;
